import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function SuperSubscriptions() {
  const [stores, setStores] = useState([]);
  const [plans, setPlans] = useState([]);

  const load = async () => {
    const [s, p] = await Promise.all([api.get("/admin/stores"), api.get("/subscription-plans")]);
    setStores(s.data); setPlans(p.data);
  };
  useEffect(() => { load(); }, []);

  const setSub = async (id, plan, status) => {
    try {
      await api.patch(`/admin/stores/${id}/subscription`, { plan, status });
      toast.success("Subscription updated");
      load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-5">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-black tracking-tight">Subscriptions</h1>
        <p className="text-gray-600 text-sm">Manage all store plans</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {plans.map((p) => {
          const count = stores.filter((s) => s.subscription_plan === p.code).length;
          return (
            <div key={p.id} className="qd-card p-4" data-testid={`super-plan-${p.code}`}>
              <div className="text-xs uppercase tracking-widest font-bold text-gray-500">{p.name}</div>
              <div className="font-heading font-black text-2xl mt-1">₹{p.price_monthly}/mo</div>
              <div className="text-xs text-gray-500 mt-2">{count} active stores</div>
            </div>
          );
        })}
      </div>

      <div className="qd-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-gray-500 border-b">
              <th className="p-3 font-semibold">Store</th>
              <th className="p-3 font-semibold">Plan</th>
              <th className="p-3 font-semibold">Status</th>
              <th className="p-3 font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {stores.map((s) => (
              <tr key={s.id} className="border-b border-gray-50">
                <td className="p-3 font-semibold">{s.name}</td>
                <td className="p-3 capitalize">{s.subscription_plan}</td>
                <td className="p-3 capitalize">
                  <span className={`text-xs px-2 py-1 rounded-full font-bold ${
                    s.subscription_status === "active" ? "bg-green-50 text-green-700" :
                    s.subscription_status === "paused" ? "bg-amber-50 text-amber-700" : "bg-red-50 text-red-700"
                  }`}>{s.subscription_status}</span>
                </td>
                <td className="p-3 space-x-1 flex flex-wrap gap-1">
                  <select defaultValue={s.subscription_plan}
                    onChange={(e) => setSub(s.id, e.target.value, s.subscription_status)}
                    className="text-xs border border-gray-200 rounded-lg px-2 py-1"
                    data-testid={`sub-plan-${s.slug}`}>
                    {plans.map((p) => <option key={p.code} value={p.code}>{p.name}</option>)}
                  </select>
                  <button onClick={() => setSub(s.id, s.subscription_plan, "active")}
                    className="text-xs px-2 py-1 rounded bg-green-100 text-green-700 font-bold"
                    data-testid={`sub-activate-${s.slug}`}>Activate</button>
                  <button onClick={() => setSub(s.id, s.subscription_plan, "paused")}
                    className="text-xs px-2 py-1 rounded bg-amber-100 text-amber-700 font-bold">Pause</button>
                  <button onClick={() => setSub(s.id, s.subscription_plan, "expired")}
                    className="text-xs px-2 py-1 rounded bg-red-100 text-red-700 font-bold">Expire</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
